import { createSlice } from "@reduxjs/toolkit"
import actions from "../../../actions";

export const reObjectFunctionTypeReducer = createSlice({
    name: 'reObjectFunctionTypeReducer',
    initialState: {
        isLoading: false,
        error: null,
        changed   : null,
        objectFuncTypes: [],
        paged: null,
    },
    reducers: {
        setLoading: (state) => {
            state.isLoading = true
            state.changed = null
        },
        setError: (state, action) => {
            state.isLoading = false
            state.error = action.payload
        },
        getPagedSuccess: (state, action) => {
            state.isLoading = false
            state.paged = action.payload
        },
        createSuccess: (state,action) => {
            state.isLoading = false
            state.changed = action.payload ? actions.create : null
        },
        saveSuccess: (state,action) => {
            state.isLoading = false
            state.changed = action.payload ? actions.update : null
        },
        getListSuccess: (state, action) => {
			state.isLoading = false
			state.objectFuncTypes = action.payload
		},
        clear: (state) => {
            state.isLoading = false
            state.changed = null
            state.objectFuncTypes = []
            state.error = null
        },
    }
})

export default reObjectFunctionTypeReducer.reducer;